import { select, put, takeLatest, call } from 'redux-saga/effects'
import { ClientDataConstants } from '../../../clientData/store/clientData.constants'
import { setPnProcedureOptions } from '../../../options/store/options.actions'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../user/selectors'
import { PNProcedureServices } from '../services/pnProcedure.service'
import { ICategoryOptionsResponse, IPnProcedureOptionsList } from '../store/pnProcedure.types'
import { IOptions } from '../../../../common/common.types'
import { OptionsService } from '../../../options/services/options.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

interface IAllPNNVOptions {
  entity: { [key: string]: IOptions[] }[]
}

export function* setPertinentNegativeProcedureOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pnProcServices = new PNProcedureServices(serviceId)
  const optionsService = new OptionsService(serviceId)
  try {
    const pnProcedureOptions: IPnProcedureOptionsList = []
    const procedureOptions: ICategoryOptionsResponse = yield call([
      pnProcServices,
      pnProcServices.getPertNegativesProcedureOptions,
    ])
    const allPNNVOptions: IAllPNNVOptions = yield call([optionsService, optionsService.getAllPNNVOptions])
    const proceduresPNNVOptions =
      allPNNVOptions.entity.reduce(
        (acc: IOptions[] | null, item: { [key: string]: IOptions[] }) => acc || item['eProcedures.03'] || null,
        null
      ) || []

    const filteredCategoryList = procedureOptions.entity
      .filter((item) => item.category !== 'Critical Care')
      .map((item) => ({
        ...item,
        category: item.category !== null ? item.category : 'Miscellaneous',
      }))

    filteredCategoryList.forEach((item1) => {
      const categoryObject = pnProcedureOptions.find((obj: { category: string }) => obj.category === item1.category)

      const categoryOptions = [
        {
          id: Number(item1.id),
          name: item1.name,
          options: [...proceduresPNNVOptions] as IOptions,
        },
      ]

      if (categoryObject) {
        categoryObject.categoryOptions.push(...categoryOptions)
      } else {
        pnProcedureOptions.push({
          category: item1.category,
          categoryOptions,
        })
      }
    })

    yield put(setPnProcedureOptions(pnProcedureOptions))
  } catch (e) {
    yield put(throwPcrException(`setPertinentNegativeProcedureOptions() error: ${e}`))
  }
}

export function* setPertinentNegativeProcedureOptionsSaga() {
  yield takeLatest(
    [ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS],
    performWithMutexHOG,
    setPertinentNegativeProcedureOptions
  )
}
